/** @format */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2"; // TUZATILDI: Paket nomi to'g'rilandi
import Card from "./Card";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

const options = {
  responsive: true,
  plugins: {
    legend: { display: false },
    title: { display: false },
    datalabels: { display: false },
    tooltip: {
      backgroundColor: "#0f172a",
      titleColor: "#fff",
      bodyColor: "#a5f3fc",
      borderColor: "#0ea5e9",
      borderWidth: 1,
      cornerRadius: 6,
      padding: 10,
      callbacks: {
        title: (context) => `Soat: ${context[0].label}:00`,
        label: (ctx) => `${ctx.formattedValue} m³/s`,
      },
    },
  },
  scales: {
    y: {
      grid: { color: "#CBD5E1" },
      border: { dash: [2, 2] },
      beginAtZero: true,
    },
    x: {
      grid: { drawOnChartArea: false, color: "#CBD5E1" },
      ticks: {
        minRotation: 0,
        maxRotation: 0,
        autoSkip: true,
        color: "#64748b",
      },
    },
  },
  elements: {
    point: {
      radius: 3,
      hoverRadius: 4,
      backgroundColor: "#22d3ee",
      borderWidth: 1,
      borderColor: "#fff",
    },
    line: {
      tension: 0.4,
    },
  },
};

const labels = Array.from({ length: 24 }, (_, i) => (i + 1).toString());

const Chart4 = ({ data }) => {
  const gradient = (ctx) => {
    const { chart } = ctx;
    const { ctx: context, chartArea } = chart;
    if (!chartArea) return null;

    const gradient = context.createLinearGradient(
        0,
        chartArea.top,
        0,
        chartArea.bottom
    );
    gradient.addColorStop(0, "rgba(34, 211, 238, 0.6)");
    gradient.addColorStop(1, "rgba(6, 182, 212, 0)");

    return gradient;
  };

  const datas = {
    labels,
    datasets: [
      {
        label: "Tezlik",
        data: data,
        borderColor: "#22d3ee",
        backgroundColor: gradient,
        fill: true,
        tension: 0.4,
      },
    ],
  };

  return (
      <Card>
        <div className='chart-box-all'>
          <div>
            <h4 className='chart-title'>
              Uchqo’rg’on tashlama{" "}
              <span className='lower' style={{ opacity: 0.75, marginLeft: '4px' }}>
              soatlik (m<sup>3</sup>/s)
            </span>
            </h4>

            <Line options={options} data={datas} height={80} />
          </div>
        </div>
      </Card>
  );
};

export default Chart4;